import React, {FC, ReactNode} from "react";
import ModalWrapper from "../ModalWrapper/ModalWrapper";

export type CustomModalProps = {
    isOpen: boolean,
    title: string | ReactNode,
    content?: string | ReactNode,
    onClickConfirm: () => void,
    confirmText: string,
    size?: string
}

const ConfirmationModalForIPRestore: FC<CustomModalProps> = ({
                                                                 isOpen = false,
                                                                 title,
                                                                 content,
                                                                 onClickConfirm,
                                                                 confirmText,
                                                                 size = 'small'
                                                             }) => (
    <ModalWrapper
        id="discard-changes-modal"
        isOpen={isOpen}
        headerText={title}
        size={size}
        buttons={[
            {
                text: `${confirmText}`,
                onClick: onClickConfirm,
                primary: true,
            }
        ]}
    >
        <div className="font-md">{content}</div>
    </ModalWrapper>
);

export default ConfirmationModalForIPRestore;